import Comment from '@assets/icons/comment.svg'
import { Icon } from './Icon'

export const CommentIcon = Icon(Comment)
